
import React from 'react';

export default function Services() {
  const services = [
    {
      icon: 'ri-route-line',
      title: 'Roteiro Personalizado',
      description:
        'Planos dia a dia sob medida, criados de acordo com suas preferências, interesses e estilo de viagem',
      features: [
        'Planejamento de rota personalizado',
        'Agenda flexível',
        'Lugares escondidos incluídos',
        'Otimizado por tempo',
      ],
    },
    {
      icon: 'ri-guide-line',
      title: 'Passeios Guiados em Nova York',
      description:
        'Experiências com guias especializados, conhecimento privilegiado e atendimento em português',
      features: [
        'Acesso sem fila',
        'Dicas locais exclusivas',
        'Oportunidades para fotos',
        'Grupos pequenos',
      ],
    },
    {
      icon: 'ri-plane-line',
      title: 'Assistência no Aeroporto',
      description:
        'Suporte completo na chegada e partida para começar sua viagem sem estresse',
      features: [
        'Serviço de recepção',
        'Auxílio com bagagem',
        'Transporte organizado',
        'Coordenação com hotel',
      ],
    },
    {
      icon: 'ri-ticket-2-line',
      title: 'Compra Estratégica de Ingressos',
      description:
        'Orientação especializada sobre quais passes comprar e como economizar nas atrações',
      features: [
        'Passes com melhor custo-benefício',
        'Reserva prioritária',
        'Combos especiais',
        'Estratégia de horários',
      ],
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Planejamento Completo da Viagem',
      description:
        'Organização total, da hospedagem às reservas em restaurantes',
      features: [
        'Indicações de hotéis',
        'Reservas em restaurantes',
        'Ingressos para shows',
        'Programação de atividades',
      ],
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Suporte Antes, Durante e Depois',
      description:
        'Assistência contínua em toda a sua experiência em Nova York',
      features: [
        'Consulta pré-viagem',
        'Suporte 24/7 durante a viagem',
        'Ajustes em tempo real',
        'Acompanhamento pós-viagem',
      ],
    },
  ];

  // Helper to safely render arrays (prevents crashes if data is malformed)
  const renderFeatures = (features) => {
    if (!Array.isArray(features)) return null;
    return features.map((feature, idx) => (
      <li
        key={idx}
        className="flex items-center gap-1.5 text-xs text-gray-300"
      >
        <i className="ri-checkbox-circle-fill text-[#D4AF37] text-xs"></i>
        {feature}
      </li>
    ));
  };

  return (
    <section id="services" className="bg-black py-24 relative overflow-hidden">
      {/* Gold accent line */}
      <div
        className="absolute top-0 left-0 right-0 h-1"
        style={{
          background:
            'linear-gradient(to right,transparent, #D4AF37, transparent)',
        }}
      ></div>

      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-3xl lg:text-4xl font-serif font-bold">
            Experiências selecionadas, pensadas para viajantes exigentes
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-[#151515] rounded-lg p-4 border border-transparent hover:border-[#D4AF37] hover:shadow-xl hover:shadow-[#D4AF37]/10 transition-all duration-300 group"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-[#D4AF37] rounded-full mb-3 group-hover:scale-110 transition-transform duration-300">
                <i
                  className={`${service.icon} text-lg text-black`}
                  aria-hidden="true"
                ></i>
              </div>
              <h3 className="text-sm font-bold mb-1.5 text-white leading-tight">
                {service.title}
              </h3>
              <p className="text-gray-400 text-xs leading-relaxed mb-3">
                {service.description}
              </p>
              <ul className="space-y-1">
                {renderFeatures(service.features)}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
